export const PUBLIC_SITE_ORIGIN = 'https://asgastronomico.com';
export const DASHBOARD_ORIGIN = 'https://dashboard.asgastronomico.com';

const STAFF_PATHS = ['/login', '/dashboard', '/design'] as const;

export function isLocalOrPreviewHost(hostname: string): boolean {
  const host = hostname.toLowerCase();
  return (
    host === 'localhost' ||
    host === '127.0.0.1' ||
    host.endsWith('.localhost') ||
    host.endsWith('.vercel.app') ||
    host.includes('staging') ||
    host.includes('preview') ||
    /^\d{1,3}(?:\.\d{1,3}){3}$/.test(host)
  );
}

export function isDashboardHost(hostname: string): boolean {
  return hostname.toLowerCase() === 'dashboard.asgastronomico.com';
}

export function isPublicSiteHost(hostname: string): boolean {
  const host = hostname.toLowerCase();
  return host === 'asgastronomico.com' || host === 'www.asgastronomico.com';
}

export function isStaffPath(pathname: string): boolean {
  return STAFF_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`));
}

export function staffAbsoluteUrl(path: string): string {
  return `${DASHBOARD_ORIGIN}${path}`;
}

/** Destino cross-origin, o null si esta URL ya está en el host correcto. */
export function resolveHostRedirect(
  hostname: string,
  pathname: string,
  search = '',
  hash = ''
): string | null {
  if (!hostname || isLocalOrPreviewHost(hostname)) return null;

  const suffix = `${pathname}${search}${hash}`;

  if (isDashboardHost(hostname)) {
    if (pathname === '/' || pathname === '') {
      return `${DASHBOARD_ORIGIN}/dashboard`;
    }
    if (isStaffPath(pathname)) return null;
    return `${PUBLIC_SITE_ORIGIN}${suffix}`;
  }

  if (isPublicSiteHost(hostname) && isStaffPath(pathname)) {
    return `${DASHBOARD_ORIGIN}${suffix}`;
  }

  return null;
}
